import { render, staticRenderFns } from "./WorkReportBottom.vue?vue&type=template&id=64ca847d&scoped=true&"
import script from "./WorkReportBottom.vue?vue&type=script&lang=js&"
export * from "./WorkReportBottom.vue?vue&type=script&lang=js&"
import style0 from "./WorkReportBottom.vue?vue&type=style&index=0&id=64ca847d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca847d",
  null
  
)

export default component.exports